const state = {
  borrow_id: null
}

const getters = {
  borrow_id: state => state.borrow_id
}

const mutations = {
  setBorrowId (state, borrow_id) {
    state.borrow_id = borrow_id
  }
}

const actions = {
  setBorrowId ({ commit }, borrow_id) {
    commit('setBorrowId', borrow_id)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
